import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable({
  providedIn: 'root'
})

export class TranslateServiceService {
  currentLanguage = "";

  constructor(private http: HttpClient) {
    this.getCurrentLanguage();
  }

  public getJSON(url): Observable<any> {
     return this.http.get(url)
  }

  public changeLanguage() {
    this.currentLanguage = localStorage.getItem('language');
    
    if (this.currentLanguage === "ES"){
      localStorage.setItem('language', "EN");
      this.currentLanguage = "EN";
    }else{
      localStorage.setItem('language', "ES");
      this.currentLanguage === "ES";
    }
  }

  public getCurrentLanguage(language = 'ES') {
    this.currentLanguage = localStorage.getItem('language');
    if(!this.currentLanguage){
      console.log('yet')
      this.currentLanguage = language;
    }
    return this.currentLanguage;
  }
}
